import React, { memo, useEffect, useReducer, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import useDashboardFilterHook from '../Shared/useDashboardFilterHook'
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest'
import { enumUtil } from '../../../../utils/Enum'
import AmountFormatter from '../../../../utils/AmountFormatter'
import DownloadCSVLink from '../../../../utils/DownloadCSVLink'
import GridColumnHeader from '../../../Setup/Shared/GridColumnHeader'
import Table from '../../../Setup/Shared/Table'
import ClusteredStackedColumnChart from '../Charts/ClusteredStackedColumnChart'
import useSidebarSubMainTab from '../../../shared/HandleOpenSidebarSubTab/useSidebarSubMainTab'

const BaseDD = [
  { value: "DOS", display: "Date of Service" },
  { value: "EntryDate", display: "Entry Date" },
  { value: "SubmittedDate", display: "Submitted" }
]

const paymentForList = [
  { value: 'System Visits', display: 'System Visits' },
  { value: 'External Visits', display: 'External Visits' },
  { value: 'All', display: 'All' },
]

const API_URL = enumUtil.controller.Dashboard

const FinancialSummary = memo((props) => {
  const { reloadData, isHomeCareCheck } = props;
  const openSidebarSubMainTab = useSidebarSubMainTab();

  const [financialSummaryData, setFinancialSummaryData] = useState([]);
  const [financialSummaryDataSorting, setFinancialSummaryDataSorting] = useState([]);
  const [isLoadingFinancialChart, setIsLoadingFinancialChart] = useState(false);
  const [activeTab, setActiveTab] = useState('Graph');
  const [reloadChart, setReloadChart] = useState(false);

  const [baseOnSearchParamsummary, setBaseOnSearchParamsummary] = useState('Date of Service');
  const [paymentForSearchParamsummary, setPaymentForSearchParamsummary] = useState('All');

  const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' });

  const LoadData = () => {
    setIsLoadingFinancialChart(true);
    setFinancialSummaryData([]);

    ServerRequestProtected(API_URL + '/GetFinancialSummaryData', 'post', {
      "TableName": enumUtil.enumAPITableName.Dashboard,
      "SearchParam": "Financial Summary",
      ...searchFinancialFilterModal
    }).then((response) => {
      setFinancialSummaryData(response);
      handleGridHeader({ defaultData: response?.[1] });
      setFinancialSummaryDataSorting(response?.[1]);
      setReloadChart(prev => !prev);
    }).catch(() => {
    }).finally(() => {
      setIsLoadingFinancialChart(false);
    });
  };

  let [
    setOpenFinancialFilter,
    searchFinancialFilterModal,
    financialFilterDiv,
    setBasedOnDateFinancial,
    basedOnDateFinancial,
    setPaymentForID,
    paymentForID,
  ] = useDashboardFilterHook(
    LoadData, 
    'Financial Summary', 
    () => {}, 
    null,
    null,
    () => {
      // -- onReset -- //  
      setBaseOnSearchParamsummary('Date of Service');
      setPaymentForSearchParamsummary('All');
    }
  );

  useEffect(() => {
    LoadData();
  }, [basedOnDateFinancial, paymentForID, reloadData]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === 'Baseonsummary') setBaseOnSearchParamsummary(value);
    if (name === 'PaymentForSummary') setPaymentForSearchParamsummary(value);
  };

  const handleSelectedDataa = (selectedData, name, type) => {
    if (type === 'client' && selectedData) {
      if (name === 'Baseonsummary') {
        setBasedOnDateFinancial(selectedData.value + "");
        setBaseOnSearchParamsummary(selectedData.display);
        if (selectedData.value !== basedOnDateFinancial) setIsLoadingFinancialChart(true);
      } else if (name === 'PaymentForSummary') {
        setPaymentForID(selectedData.value + "");
        setPaymentForSearchParamsummary(selectedData.display);
        if (selectedData.value !== paymentForID) setIsLoadingFinancialChart(true);
      }
    } else {
      if (name === 'Baseonsummary') setBaseOnSearchParamsummary('');
      if (name === 'PaymentForSummary') setPaymentForSearchParamsummary('');
    }
    return selectedData;
  };

  const financialSummColumns = [
    {
      key: 'Date',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Date'} sortIcon={true} type={'string'} colKey={'Date'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
    },
    {
      key: 'Charges',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Charges'} sortIcon={true} type={'string'} colKey={'Charges'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Reports-413-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row?.Charges} />
        </div>
      )
    },
    {
      key: 'Billed',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Billed'} sortIcon={true} type={'string'} colKey={'Billed'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Reports-413-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}","Submitted":"1"}`
        )}>
          <AmountFormatter amount={row?.Billed} />
        </div>
      )
    },
    {
      key: 'Not Billed',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Not Billed'} sortIcon={true} type={'string'} colKey={'Not Billed'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Claims-71-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row?.['Not Billed']} />
        </div>
      )
    },
    ...(isHomeCareCheck ? [] : [{
      key: 'Patient Payment',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Pat. Payment'} sortIcon={true} type={'string'} colKey={'Patient Payment'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Reports-434-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row?.['Patient Payment']} />
        </div>
      )
    }]),
    {
      key: 'Insurance Payment',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Ins. Payment'} sortIcon={true} type={'string'} colKey={'Insurance Payment'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Reports-413-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row?.['Insurance Payment']} />
        </div>
      )
    },
    {
      key: 'Denied',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Denied'} sortIcon={true} type={'string'} colKey={'Denied'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Account Receivables-7222-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row.Denied} />
        </div>
      )
    },
    {
      key: 'Adjustment',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Adjustment'} sortIcon={true} type={'string'} colKey={'Adjustment'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Reports-413-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row.Adjustment} />
        </div>
      )
    },
    {
      key: 'WriteOff',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'WriteOff'} sortIcon={true} type={'string'} colKey={'WriteOff'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Reports-4310-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row.WriteOff} />
        </div>
      )
    },
    {
      key: 'Balance',
      name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        iconName={'iicon-Icon-awesome-user-tie'} headerName={'Balance'} sortIcon={true} type={'string'} colKey={'Balance'} data={financialSummaryDataSorting} setData={setFinancialSummaryDataSorting} />),
      renderCell: ({ row }) => (
        <div className="slim_link_hover" onClick={() => openSidebarSubMainTab(
          `Reports-432-{"DateType":"${searchFinancialFilterModal.SearchCriteria.Value} ${row.DateNames}"}`
        )}>
          <AmountFormatter amount={row.Balance} />
        </div>
      )
    },
  ];

  return (
    <div className="border-0 card_tabs filter-row">
      <div className="align-items-center br-bottom-1 d-flex justify-content-between mb-06-px pb-1-5 position-relative za_br_light">
        <div className="d-flex align-items-center gap-2">
          <p className="heading text-black fs-15">Financial Summary</p>
          <p className="za-dot text fst-italic fs-11">{financialSummaryData?.[2]?.DateRange}</p>
        </div>
        <div className="ar_views d-flex cursor-pointer">
          <p className={`${activeTab === 'Graph' ? 'active' : ''}`} onClick={() => setActiveTab('Graph')}>
            <div className="app_tooltip left w-100 h-100 align-items-center justify-content-center">
              <i className="bi-bar-chart-line ar-light-color fs-16 lh-16"></i>
              <p className="tool_tip xsm_text text-light">Graph View</p>
            </div>
          </p>
          <p className={`${activeTab === 'Grid' ? 'active' : ''}`} onClick={() => setActiveTab('Grid')}>
            <div className="app_tooltip right w-100 h-100 align-items-center justify-content-center">
              <i className="bi bi-grid-3x3 fs-16 lh-16 ar-light-color"></i>
              <p className="tool_tip xsm_text text-light">Grid View</p>
            </div>
          </p>
        </div>

        <span className="ar_dash-filter d-flex align-items-center gap-2">
          {isLoadingFinancialChart ?
            (<div className="ar-small-loader last_loader">
              <div className="circle circle1"></div>
              <div className="circle circle2"></div>
            </div>) : <></>}
          <div className="w-130px">
            <SuperSearchList
              type="client"
              id='Baseonsummary'
              name='Baseonsummary'
              searchValue={baseOnSearchParamsummary}
              data={BaseDD}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedDataa}
              icon={'Simple'}
              sup_btn='sup_btn'
              sup_inp='superSearchVisitInp'
            />
          </div>
          <div className="w-130px">
            <SuperSearchList
              type="client"
              id='PaymentForSummary'
              name='PaymentForSummary'
              searchValue={paymentForSearchParamsummary}
              data={paymentForList}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedDataa}
              icon={'Simple'}
              sup_btn='sup_btn'
              sup_inp='superSearchVisitInp'
            />
          </div>
          <div className="app_tooltip left">
            <i className="icon-Icon-awesome-filter fs-16" onClick={() => setOpenFinancialFilter(prev => !prev)}></i>
            <p className="tool_tip xsm_text text-light">Filters</p>
          </div>
          {activeTab === 'Grid' ?
            financialSummaryData?.[1] &&
            <DownloadCSVLink name={"FinancialSummaryData.csv"} data={financialSummaryData?.[1]} columns={financialSummColumns} />
            : <></>}
        </span>
        {financialFilterDiv}
      </div>
      <div>
        {activeTab === 'Graph' ?
          financialSummaryData?.[0]?.length > 0 ?
            <ClusteredStackedColumnChart key={reloadChart} data={financialSummaryData?.[0]} FinancialFilterDateType={searchFinancialFilterModal.SearchCriteria.Value} />
            :
            <div style={{ height: 350 }}></div> :
          activeTab === 'Grid' ?
            <div>
              <Table
                columns={financialSummColumns}
                dynamicClass='BorderLess-Grid DataGrid-Table hk-exp-table mt-2 overflow-auto Scroll-width'
                rowHeight={25}
                rows={financialSummaryDataSorting || []}
                height='365px'
                hidePagination={true}
                isLoading={true}
                hideColClass={'hide'}
              />
            </div> : <></>}
      </div>
    </div>
  );
});

export default FinancialSummary;